module.exports = __webpack_public_path__ + "static/oil-ef3187f32bd83cc2aad79b9a86a11735.mp4";